export default {
  name: "recentlyViewedSection",
  data() {
    return {
        recentlyViewed:[]
    };
  },
  created() {
      this.recentlyViewed=this.$store.getters.getUserInfo.viewedProduct
  },
  methods:{
    detailArticlePage(id) {
        return "/detail-article?id_article=" + id;
      },
    imgElement(element) {
        if (element.typeArticle == "vetements") {
          return (
            "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
            element.vetements[0].image[0]
          );
        } else if (element.typeArticle == "chaussure") {
          return (
            "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
            element.chaussure[0].image[0]
          );
        } else if (element.typeArticle == "tapis") {
          return (
            "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
            element.tapis[0].image[0]
          );
        } else if (element.typeArticle == "autre") {
          return (
            "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
            element.autre[0].image[0]
          );
        }
      },
  }
};
